import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Last resort for UNCAUGHT errors — template/runtime failures and unhandled
 * promise rejections that no `error:` callback caught. These used to die
 * silently in the console; now the user gets one generic message.
 *
 * HTTP failures are deliberately ignored here: every call goes through
 * ApiService, and call sites already surface them via `apiError()` + a
 * snackbar. Handling them again would double-toast. They are still logged.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private snack = inject(MatSnackBar);
  private zone = inject(NgZone);

  handleError(error: unknown): void {
    // eslint-disable-next-line no-console
    console.error(error);

    if (error instanceof HttpErrorResponse) return; // shown at the call site

    // ErrorHandler can fire outside Angular's zone; open the snackbar inside it.
    this.zone.run(() =>
      this.snack.open('Something went wrong. Please try again.', 'Dismiss', { duration: 4000 }),
    );
  }
}
